import React, { useContext } from "react";
import homeimg from "../../assests/prehome.png";
import { useNavigate } from "react-router-dom";
import { GlobalStateContext } from "../../App";
// import item from '../../assests/items.png';

function Prehome({ state }) {
  const navigate = useNavigate();
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const userData = globalState?.userData;

  return (
    <>
      <div className="relative w-full flex justify-center items-center -mt-[2%]">
        <img src={homeimg} alt="home img" className=" w-full lg:w-[55%]" />
        <button
        onClick={() => {
          if (userData) {
            localStorage.setItem("rgs_email", userData?.email);
            navigate("/customizer?stage=0");
          } else navigate("/start");
        }}
        className="absolute top-[50%] left-[50%] transform !translate-x-[-50%] !translate-y-[-50%] bg-[#02595A] text-white px-10 py-2 rounded-full text-[18px] focus:border border-[#0F0F0F] border-solid transition-transform duration-300 animate-pulsate z-10"
      >
        DESIGN NOW!
      </button>
      </div>

      <div className=" flex justify-end px-[250px]">
        <p className="text-[10px] text-[#616160] mt-[-85px]">
          {" "}
          *ITEMS NOT TO SCALE
        </p>
      </div>
      {/* <div className="font-ZapfHumanist flex justify-center items-center text-center mt-0">
        <p className="text-[24px]">
          WELCOME TO{" "}
          <span style={{ fontFamily: "ZapfHumanistBold" }}>
            COLLECTION CREATOR{" "}
          </span>
          <p>BY</p>{" "}
          <p style={{ fontFamily: "ZapfHumanistBold" }}>
            PARIFY PACKAGING
          </p>
        </p>
        <br />
      </div> */}
      <div className="flex flex-col lg:flex-row justify-center items-center text-center mt-0 gap-6 mb-8">
        <p
          className="text-[25px] text-[#04595a]"
          style={{ fontFamily: "AmalfiCoast" }}
        >
          Collection Creator
        </p>
        <div className="text-[19px] text-[#616160] flex gap-6">
          <div className="flex gap-2">
            <p>P</p>
            <p>A</p>
            <p>C</p>
            <p>K</p>
            <p>A</p>
            <p>G</p>
            <p>I</p>
            <p>N</p>
            <p>G</p>
          </div>
          <div className="flex gap-2">
            <p>D</p>
            <p>E</p>
            <p>S</p>
            <p>I</p>
            <p>G</p>
            <p>N</p>
            <p>E</p>
            <p>D</p>
          </div>
          <div className="flex gap-2">
            <p>B</p>
            <p>Y</p>
          </div>
        </div>
        <p
          className="text-[25px] text-[#04595a]"
          style={{ fontFamily: "AmalfiCoast" }}
        >
          You!
        </p>
      </div>
      <div className="flex justify-center items-center text-center m-4">
        <p className="text-[14px]">
          Create your packaging online instantly!
          <br />
          {/* Click below to get started... */}
        </p>
      </div>
      <div className="flex justify-center mb-6">
        {/* <button
          onClick={() => {
            navigate("/home");
          }}
          className="flex justify-center bg-[#02595A] text-white px-10 py-2 rounded-full  text-[18px]  focus:border border-[#0F0F0F] border-solid transition-transform duration-300 hover:scale-110 animate-pulsate"
        >
          DESIGN NOW!
        </button> */}
      </div>
    </>
  );
}

export default Prehome;
